<template lang="pug">
.item.d-flex.flex-column.align-items-center
  img(:src="icon")
  p.text-center {{ title }}
</template>

<script>
export default {
  name: "Item",
  props: {
    title: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.item {
  width: 140px;
}

img {
  @include square(50px);
}

p {
  margin-top: 12px;
  max-width: 128px;
}

@media (max-width: 991px) {
  .item {
    width: 133px;
  }

  img {
    @include square(40px);
  }

  p {
    font-size: 14px;
    // max-width: 60px;
  }
}

@media (max-width: 767px) {
  .item {
    width: 137px;
  }

  img {
    @include square(88px);
  }

  p {
    font-size: 22px;
    max-width: 137px;
  }
}

@media (max-width: 575px) {
  .item {
    width: 23.7vw;
  }

  img {
    @include square(15.2vw);
  }

  p {
    line-height: 7.35vw;
    font-size: 4.2vw;
    max-width: 23.7vw;
  }
}
</style>
